import api from "./http";

class LoginService {
  static login(data) {
    return api.post(`/auth/login`, data);
  }
}

export default LoginService;
